import { Component, OnInit, ViewChild } from '@angular/core';
import { MenuItem, MessageService } from 'primeng/api';
import { TokenService } from 'src/app/services/common/token.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { JEService } from 'src/app/services/je-services.service';
import { first, shareReplay } from 'rxjs';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { Router } from '@angular/router';
import { Table } from 'primeng/table';
import { DashboardService } from 'src/app/services/dashboard.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import saveAs from 'file-saver';
import { BaseService } from 'src/app/services/common/base.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';


@Component({
  selector: 'app-tank-stage3-pending',
  templateUrl: './tank-stage3-pending.component.html',
  styleUrls: ['./tank-stage3-pending.component.scss']
})
export class TankStage3PendingComponent implements OnInit {

  @ViewChild('appVerificationTable', { static: true }) public appVerificationTable: Table;
  userId: any;
  application: any;
  public tankData: any;
  displayTankDialog : boolean = false;
  selectedApplication: any;
  pondVerData: any;
  selectedStatus: any;
  remarks: any;
  items: any[];
  actualSubsidyStage3 : string;
  isSubmitted: boolean = false;

  ipAddress: any = '000.000.000';
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  appVerificationItems:MenuItem[];
  appVerificationModel:any[];
  
  public loading: boolean = false;
  public subscriptions: any = [];
  public subjectSub:any;
  public selectedYear:any;

  public surveyStage1JE: any = null;
  public surveyStage1XEN: any = null;

  public surveyStage2JE: any = null;
  public surveyStage2XEN: any = null;

  public calStage1JE: any = null;
  public calStage1DD: any = null;
  public calStage1DA: any = null;
  public calStage1DMICADA: any = null;
  public calStage1Admin: any = null;

  public calStage2JE: any = null;
  public calStage2DA: any = null;
  public calStage2DD: any = null;
  public calStage2DMICADA: any = null;
  public calStage2Admin: any = null;

  public tankStage3Data: any = null;
  public remarksData: any = null;
  public StateShare_Amount: any;
  public CenterShare_Amount: any;
  public TopUp_Amount: any;
  public ABY_Amount: any;

  public viewWorkFlowAllStatus: boolean = false;

  constructor(private messageService: MessageService,
    private pondService: JEService,
    private tokenService: TokenService,
    private deptDashBoardService: DepartmentDashboardService, 
    public router: Router, 
    private dashboard: DashboardService, 
    private ipService: IpAddressService, 
    private activityRecordService: ActivityRecordService,
    private loader: AppLoaderService,
    private service: BaseService,
    private cryptoJsService: CryptoJsService,
    ) { }

  ngOnInit(): void {
    this.getIP();
    // this.loadData();
    this.loadDataAndApplyFilter();
    this.appVerificationItems = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.appVerificationModel, 'Tank_Stage_export');
        },
      },
      {
        label: 'Download Pdf',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.downloadSheetAsPdf(
            this.appVerificationModel,
            'Tank_Stage_export'
          );
        },
      },
    ];
    // this.appVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
  }

  loadDataAndApplyFilter(){
    if(sessionStorage.getItem('financialYear')){
      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'))    
    }

    this.subjectSub= this.service.getSelectedYear().pipe(shareReplay()).subscribe(
      (res) => {

        
        this.selectedYear = res;
        this.loadData();
        this.appVerificationTable.filters['FinYear'] = [
          { value: this.selectedYear, matchMode: 'startsWith', operator: 'and' },];
      }
    );
  }

  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
    if(this.subjectSub){
      this.subjectSub.unsubscribe();
    }
  }


  getStatusItems(){
    // let actionId = 31; // Do not Change,
    let actionId = 25; // Do not Change,
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.loader.start();
    this.deptDashBoardService.GetStatusMaster(JSON.parse(payload)?.sub, actionId)
    .pipe(first())
    .subscribe({
      next: (data) => {
        this.loader.close();
        this.items = data.$values;
      },
      error: () => {
        this.loader.close();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Status Master cant be Loaded' });
      }
    });
  }

  loadData() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;
    if(this.userId == 'Admin2'){
      this.userId = 'Admin';
    }
    // this.loader.start();
    this.loading = true;
    let sub = this.pondService
      .GetFarmerAppForPondVer_SubsidyCalc_Stage3(this.userId, 'Pending', this.selectedYear)
      .pipe(first())
      .subscribe({
        next: (data) => {
          
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-3 Survey(Pending) Action Submit', '', new Date(), 'Success');

          this.tankData = data;

          if(this.tankData && this.tankData?.length > 0){
            this.tankData.forEach(e=>{  
              e.AssignedDate = new Date(e?.AssignedDate);
            })
          }

          this.appVerificationModel = this.tankData;

          // this.loader.close();
          this.loading = false;
          this.getStatusItems();
        },
        error: (err) => {
          this.tankData = [];
          // this.loader.close();
          this.loading = false;
          this.activityRecordService.activityRecord(this.userId, 'Tank Stage-3 Survey(Pending) Action Submit', '', new Date(), err);

          if(err == 'Data not Found!'){
            this.messageService.add({ severity: 'warn', summary: 'Info Message', detail: err });
          }else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: err });
          }
        },
      });

      this.subscriptions.push(sub);
  }

  refreshTable() {
    this.loadData();
    // this.appVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'APP ID': d.appID,
          'App type': d.FarmerName,
          'District': d.District,
          'block': d.Block,
          "Village": d.Village,
          'Total Area': d.Total_Area,
          'Age Of Application': d.AgeOfApplication,
          'Pending Completed Days': d.PendingCompletedDays,
          'Land Detail': d.LandDetail,
          'status': d.Status,
          'Current Status': d.Status_Ar,
          
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }
  downloadSheetAsPdf(modelData, filename) {
    this.cols = [
      { field: 'appID', header: 'appID' },
      { field: 'FarmerName', header: 'Farmer Name' },
      { field: 'District', header: 'district' },
      { field: 'Block', header: 'block' },
      { field: 'Village', header: 'village' },
      { field: 'Total_Area', header: 'Total Area' },
      { field: 'AgeOfApplication', header: 'Age Of Application' },
      { field: 'PendingCompletedDays', header: 'Pending Completed Days' },
      { field: 'LandDetail', header: 'Land Detail' },
      { field: 'Status', header: 'Status' },
      { field: 'Status_Ar', header: 'Current Status' },
    ];

    this.exportColumns = this.cols.map((col) => ({
      title: col.header,
      dataKey: col.field,
    }));

    import('jspdf').then((jsPDF) => {
      import('jspdf-autotable').then((x) => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(this.exportColumns, modelData, {styles: {fontSize: 6 }});

        doc.save(`${filename}.pdf`);
      });
    });
  }

  selectTankRowData(application){
    this.viewWorkFlowAllStatus = false;
    this.displayTankDialog = true;
    this.selectedApplication = application;
    if(application.appID){
      this.pondService
      .getPondVerDataByAppId_SubsidyCalc_Stage3(application.appID)
      .pipe(first())
      .subscribe({
        next: (res) => {
           // this.pondVerData = res;

           this.surveyStage1JE = res[1][0];
           this.surveyStage1XEN = res[0][0];
 
           this.surveyStage2JE = res[3][0];
           this.surveyStage2XEN = res[2][0];      
 
           this.calStage1JE = res[5][0];
           this.calStage1DD = res[6][0];
           this.calStage1DA = res[7][0];
           this.calStage1DMICADA = res[8][0];
           this.calStage1Admin = res[4][0];
 
           this.calStage2JE = res[10][0];
           this.calStage2DD = res[11][0];
           this.calStage2DA = res[12][0];
           this.calStage2DMICADA = res[13][0];
           this.calStage2Admin = res[9][0];
 
           this.tankStage3Data = res[14][0];
           this.remarksData = res[15][0];
 
           if(this.tankStage3Data){
              this.CenterShare_Amount = this.tankStage3Data?.CenterShare_Amount_Calc;
              this.StateShare_Amount = this.tankStage3Data?.StateShare_Amount_Calc;
              this.ABY_Amount = this.tankStage3Data?.ABY ? this.tankStage3Data?.ABY : 0;
              this.TopUp_Amount = this.tankStage3Data?.Topup;
              this.actualSubsidyStage3 = this.tankStage3Data?.ActualSubsidyStg3;
           }
        },
        error: (err) => {
          // console.log("error", err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  onCloseDialog(){
    this.displayTankDialog = false;
    this.remarks=''
  }

  viewFarmerApplication(application) {
    if(application.appID){
      // const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.appID)]));
      const link = this.router.serializeUrl(
        this.router.createUrlTree([
          this.router.url.split('/')[1],
          'print',
        ],  { queryParams: { appId:this.cryptoJsService.Encrypt(application.appID.toString()) } }));
      window.open(link, '_blank');
      // this.dashboard
      // .getMIDetailByAppID(application.appID)
      // .pipe(first())
      // .subscribe({
      //   next: (res) => {
      //     const link = this.router.serializeUrl(this.router.createUrlTree([this.router.url.split('/')[1], 'print', this.cryptoJsService.Encrypt(application.appID), ,res[0]?.VendorId,res[0]?.ProgId,res[0]?.User_ID,res[0]?.AutoId]));
      //     window.open(link, '_blank');
      //   },
      //   error: (err) => {
      //     console.log("error", err);
      //     this.messageService.add({
      //       severity: 'error',
      //       summary: 'Error Message',
      //       detail: err,
      //     });
      //   },
      // });
    }
     else {
      this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Invalid App ID' });
    }
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    }else{
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress',JSON.stringify(this.ipAddress));
      });
    }
  }

  handleClick(){
    this.isSubmitted = true;
    if(!this.actualSubsidyStage3){
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Actual Subsidy Stage 3 Cannot be empty.',
      });
      return;
    }
    let body = {
      appID: this.selectedApplication?.appID,
      miSurvey_ID: this.pondVerData?.MISurveyID,
      actualSubsidy_Stage3: parseFloat(this.actualSubsidyStage3),
      stateShare_Amount: this.pondVerData?.StateShare_Amount,
      centerShare_Amount: this.pondVerData?.CenterShare_Amount,
      userID: this.userId,
      remarks: this.remarks ? this.remarks : '',
      status: this.selectedStatus?.flag,
      networkId: this.ipAddress,
      terminalId: this.ipAddress
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(body))
    }

    this.loader.start();
    this.pondService
      .insertPondSurvey_SubsidyCalc_Stage3(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (data) => {
          // let index=this.tankData.findIndex(e=>{return e.appID==body.appID})
          // let index1=this.appVerificationTable.filteredValue.findIndex(e=>{return e.appID==body.appID})
          // this.tankData.splice(index,1)
          // this.appVerificationTable.filteredValue.splice(index1,1)
          // this.appVerificationTable.filters['Status_Ar'] = [{ value: "P", matchMode: "startsWith", operator: "and" }];
          if(data == "S:Successfully Updated"){
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data.toString(),
            });

            this.refreshTable();
          }else{
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data.toString(),
            });
          }
          this.onCloseDialog();
          this.loader.close();
          // this.loadData();
         
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Dashboard not loaded.',
          });
        },
      });
  }
  rowBackgroundColor(product){
    if(product.Status_Ar == 'P'){
      if(product.Pending_CompletedDays <= -2){
        return '#ff8080';
      }
      else if(product.Pending_CompletedDays == -1){
        return '#ffc966';
      }
    }
    else if(product.Status_Ar == 'C' || product.Status_Ar == 'A'){
      if(product.Pending_CompletedDays >= -1){
        return '#99e699';
      }
      else if(product.Pending_CompletedDays <= -2){
        return '#ffb3b3';
      }
    }
    else
      return '#ffffff';
  }

  workFlowAllStatus() {
    this.viewWorkFlowAllStatus = true;
  }
}
